import { gql } from '@apollo/client'

export const PARTY_TIMEOUT_SUBSCRIPTION = gql`
  subscription PartyTimeout {
    partyTimeout
  }
`
